// AUTO-GENERATED by sync-icons — do not edit.
import AiSparkIconSvg from './AiSparkIcon';
import AlertsIconSvg from './AlertsIcon';
import CalendarIconSvg from './CalendarIcon';
import CameraIconSvg from './CameraIcon';
import ChargingBoostIconSvg from './ChargingBoostIcon';
import ChatIconSvg from './ChatIcon';
import ClockIconSvg from './ClockIcon';
import ColdIconSvg from './ColdIcon';
import CombineIconSvg from './CombineIcon';
import CompareBarsIconSvg from './CompareBarsIcon';
import ConnectionIconSvg from './ConnectionIcon';
import CookingOnGasIconSvg from './CookingOnGasIcon';
import CoolingFreezingIconSvg from './CoolingFreezingIcon';
import DeleteIconSvg from './DeleteIcon';
import DiscountAltIconSvg from './DiscountAltIcon';
import DiscountIconSvg from './DiscountIcon';
import DishwasherIconSvg from './DishwasherIcon';
import DocumentIconSvg from './DocumentIcon';
import DongleIconSvg from './DongleIcon';
import DotIconSvg from './DotIcon';
import DownloadIconSvg from './DownloadIcon';
import DryerIconSvg from './DryerIcon';
import DuplicateIconSvg from './DuplicateIcon';
import EditIconSvg from './EditIcon';
import ElectricVehicleIconSvg from './ElectricVehicleIcon';
import EntertainmentIconSvg from './EntertainmentIcon';
import EnvelopeIconSvg from './EnvelopeIcon';
import EuroDiscountIconSvg from './EuroDiscountIcon';
import EuroIconSvg from './EuroIcon';
import ExternalIconSvg from './ExternalIcon';
import FatCrossIconSvg from './FatCrossIcon';
import FlagIconSvg from './FlagIcon';
import ForbiddenIconSvg from './ForbiddenIcon';
import GiftIconSvg from './GiftIcon';
import HamburgerMenuIconSvg from './HamburgerMenuIcon';
import HeartIconSvg from './HeartIcon';
import HeatingIconSvg from './HeatingIcon';
import HelpIconSvg from './HelpIcon';
import HumidityLevelIconSvg from './HumidityLevelIcon';
import ImageIconSvg from './ImageIcon';
import InsulationIconSvg from './InsulationIcon';
import KitchenAppliancesIconSvg from './KitchenAppliancesIcon';
import LabelIconSvg from './LabelIcon';
import LocationIconSvg from './LocationIcon';
import LockedIconSvg from './LockedIcon';
import LogoutIconSvg from './LogoutIcon';
import MaximizeIconSvg from './MaximizeIcon';
import MeterIconSvg from './MeterIcon';
import MinimizeIconSvg from './MinimizeIcon';
import MinusIconSvg from './MinusIcon';
import NotHomeIconSvg from './NotHomeIcon';
import OrderPackageIconSvg from './OrderPackageIcon';
import OtherCategoryIconSvg from './OtherCategoryIcon';
import PeakUsageIconSvg from './PeakUsageIcon';
import PhoneIconSvg from './PhoneIcon';
import PlayIconSvg from './PlayIcon';
import PlugInIconSvg from './PlugInIcon';
import PlugOffIconSvg from './PlugOffIcon';
import PlugOnIconSvg from './PlugOnIcon';
import PlusIconSvg from './PlusIcon';
import ProfileIconSvg from './ProfileIcon';
import RecycleIconSvg from './RecycleIcon';
import ResultIconSvg from './ResultIcon';
import SaveIconSvg from './SaveIcon';
import SearchIconSvg from './SearchIcon';
import SendIconSvg from './SendIcon';
import SmartChargingIconSvg from './SmartChargingIcon';
import SmileIconSvg from './SmileIcon';
import SolarChargingIconSvg from './SolarChargingIcon';
import SplitterIconSvg from './SplitterIcon';
import StandbyConsumptionIconSvg from './StandbyConsumptionIcon';
import StandbyDetectiveIconSvg from './StandbyDetectiveIcon';
import StarEmptyIconSvg from './StarEmptyIcon';
import StarFullIconSvg from './StarFullIcon';
import StarHalfIconSvg from './StarHalfIcon';
import StarOnSquareIconSvg from './StarOnSquareIcon';
import SuitcaseIconSvg from './SuitcaseIcon';
import SupportIconSvg from './SupportIcon';
import TemperatureIconSvg from './TemperatureIcon';
import ThermometerIconSvg from './ThermometerIcon';
import ThermostatIconSvg from './ThermostatIcon';
import TouchIconSvg from './TouchIcon';
import TruckIconSvg from './TruckIcon';
import UnlockedIconSvg from './UnlockedIcon';
import UploadIconSvg from './UploadIcon';
import WarmthWarmWaterIconSvg from './WarmthWarmWaterIcon';
import WashingMachineIconSvg from './WashingMachineIcon';
import WaterHotIconSvg from './WaterHotIcon';
import WaterIconSvg from './WaterIcon';
import WeatherSunIconSvg from './WeatherSunIcon';
import WeekScheduleIconSvg from './WeekScheduleIcon';
import WhiteGoodsIconSvg from './WhiteGoodsIcon';
import WifiIconSvg from './WifiIcon';
import WorldIconSvg from './WorldIcon';
import WrenchIconSvg from './WrenchIcon';
import { withIconWrapper } from '../../IconWrapper';
export const AiSparkIcon = withIconWrapper(AiSparkIconSvg);
export const AlertsIcon = withIconWrapper(AlertsIconSvg);
export const CalendarIcon = withIconWrapper(CalendarIconSvg);
export const CameraIcon = withIconWrapper(CameraIconSvg);
export const ChargingBoostIcon = withIconWrapper(ChargingBoostIconSvg);
export const ChatIcon = withIconWrapper(ChatIconSvg);
export const ClockIcon = withIconWrapper(ClockIconSvg);
export const ColdIcon = withIconWrapper(ColdIconSvg);
export const CombineIcon = withIconWrapper(CombineIconSvg);
export const CompareBarsIcon = withIconWrapper(CompareBarsIconSvg);
export const ConnectionIcon = withIconWrapper(ConnectionIconSvg);
export const CookingOnGasIcon = withIconWrapper(CookingOnGasIconSvg);
export const CoolingFreezingIcon = withIconWrapper(CoolingFreezingIconSvg);
export const DeleteIcon = withIconWrapper(DeleteIconSvg);
export const DiscountAltIcon = withIconWrapper(DiscountAltIconSvg);
export const DiscountIcon = withIconWrapper(DiscountIconSvg);
export const DishwasherIcon = withIconWrapper(DishwasherIconSvg);
export const DocumentIcon = withIconWrapper(DocumentIconSvg);
export const DongleIcon = withIconWrapper(DongleIconSvg);
export const DotIcon = withIconWrapper(DotIconSvg);
export const DownloadIcon = withIconWrapper(DownloadIconSvg);
export const DryerIcon = withIconWrapper(DryerIconSvg);
export const DuplicateIcon = withIconWrapper(DuplicateIconSvg);
export const EditIcon = withIconWrapper(EditIconSvg);
export const ElectricVehicleIcon = withIconWrapper(ElectricVehicleIconSvg);
export const EntertainmentIcon = withIconWrapper(EntertainmentIconSvg);
export const EnvelopeIcon = withIconWrapper(EnvelopeIconSvg);
export const EuroDiscountIcon = withIconWrapper(EuroDiscountIconSvg);
export const EuroIcon = withIconWrapper(EuroIconSvg);
export const ExternalIcon = withIconWrapper(ExternalIconSvg);
export const FatCrossIcon = withIconWrapper(FatCrossIconSvg);
export const FlagIcon = withIconWrapper(FlagIconSvg);
export const ForbiddenIcon = withIconWrapper(ForbiddenIconSvg);
export const GiftIcon = withIconWrapper(GiftIconSvg);
export const HamburgerMenuIcon = withIconWrapper(HamburgerMenuIconSvg);
export const HeartIcon = withIconWrapper(HeartIconSvg);
export const HeatingIcon = withIconWrapper(HeatingIconSvg);
export const HelpIcon = withIconWrapper(HelpIconSvg);
export const HumidityLevelIcon = withIconWrapper(HumidityLevelIconSvg);
export const ImageIcon = withIconWrapper(ImageIconSvg);
export const InsulationIcon = withIconWrapper(InsulationIconSvg);
export const KitchenAppliancesIcon = withIconWrapper(KitchenAppliancesIconSvg);
export const LabelIcon = withIconWrapper(LabelIconSvg);
export const LocationIcon = withIconWrapper(LocationIconSvg);
export const LockedIcon = withIconWrapper(LockedIconSvg);
export const LogoutIcon = withIconWrapper(LogoutIconSvg);
export const MaximizeIcon = withIconWrapper(MaximizeIconSvg);
export const MeterIcon = withIconWrapper(MeterIconSvg);
export const MinimizeIcon = withIconWrapper(MinimizeIconSvg);
export const MinusIcon = withIconWrapper(MinusIconSvg);
export const NotHomeIcon = withIconWrapper(NotHomeIconSvg);
export const OrderPackageIcon = withIconWrapper(OrderPackageIconSvg);
export const OtherCategoryIcon = withIconWrapper(OtherCategoryIconSvg);
export const PeakUsageIcon = withIconWrapper(PeakUsageIconSvg);
export const PhoneIcon = withIconWrapper(PhoneIconSvg);
export const PlayIcon = withIconWrapper(PlayIconSvg);
export const PlugInIcon = withIconWrapper(PlugInIconSvg);
export const PlugOffIcon = withIconWrapper(PlugOffIconSvg);
export const PlugOnIcon = withIconWrapper(PlugOnIconSvg);
export const PlusIcon = withIconWrapper(PlusIconSvg);
export const ProfileIcon = withIconWrapper(ProfileIconSvg);
export const RecycleIcon = withIconWrapper(RecycleIconSvg);
export const ResultIcon = withIconWrapper(ResultIconSvg);
export const SaveIcon = withIconWrapper(SaveIconSvg);
export const SearchIcon = withIconWrapper(SearchIconSvg);
export const SendIcon = withIconWrapper(SendIconSvg);
export const SmartChargingIcon = withIconWrapper(SmartChargingIconSvg);
export const SmileIcon = withIconWrapper(SmileIconSvg);
export const SolarChargingIcon = withIconWrapper(SolarChargingIconSvg);
export const SplitterIcon = withIconWrapper(SplitterIconSvg);
export const StandbyConsumptionIcon = withIconWrapper(StandbyConsumptionIconSvg);
export const StandbyDetectiveIcon = withIconWrapper(StandbyDetectiveIconSvg);
export const StarEmptyIcon = withIconWrapper(StarEmptyIconSvg);
export const StarFullIcon = withIconWrapper(StarFullIconSvg);
export const StarHalfIcon = withIconWrapper(StarHalfIconSvg);
export const StarOnSquareIcon = withIconWrapper(StarOnSquareIconSvg);
export const SuitcaseIcon = withIconWrapper(SuitcaseIconSvg);
export const SupportIcon = withIconWrapper(SupportIconSvg);
export const TemperatureIcon = withIconWrapper(TemperatureIconSvg);
export const ThermometerIcon = withIconWrapper(ThermometerIconSvg);
export const ThermostatIcon = withIconWrapper(ThermostatIconSvg);
export const TouchIcon = withIconWrapper(TouchIconSvg);
export const TruckIcon = withIconWrapper(TruckIconSvg);
export const UnlockedIcon = withIconWrapper(UnlockedIconSvg);
export const UploadIcon = withIconWrapper(UploadIconSvg);
export const WarmthWarmWaterIcon = withIconWrapper(WarmthWarmWaterIconSvg);
export const WashingMachineIcon = withIconWrapper(WashingMachineIconSvg);
export const WaterHotIcon = withIconWrapper(WaterHotIconSvg);
export const WaterIcon = withIconWrapper(WaterIconSvg);
export const WeatherSunIcon = withIconWrapper(WeatherSunIconSvg);
export const WeekScheduleIcon = withIconWrapper(WeekScheduleIconSvg);
export const WhiteGoodsIcon = withIconWrapper(WhiteGoodsIconSvg);
export const WifiIcon = withIconWrapper(WifiIconSvg);
export const WorldIcon = withIconWrapper(WorldIconSvg);
export const WrenchIcon = withIconWrapper(WrenchIconSvg);
